import { ACCESS_CHECK_LINE, ACCESS_CHECK_SUBLINE } from "@/lib/wrong-part-of-town";
import { BrandSpinner } from "@/components/BrandSpinner";

/**
 * A waiting state with words. A bare spinner reads as "broken", so the crew
 * access check shows the mark plus a plain line about what's happening.
 */
export function AccessCheck() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <BrandSpinner size="lg" label="Checking your access" />
      <p className="text-sm font-semibold tracking-wide text-foreground">{ACCESS_CHECK_LINE}</p>
      <p className="text-xs text-muted-foreground">{ACCESS_CHECK_SUBLINE}</p>
    </div>
  );
}
